import { render, staticRenderFns } from "./CobrancaListFilters.vue?vue&type=template&id=b227bfe2&"
import script from "./CobrancaListFilters.vue?vue&type=script&lang=js&"
export * from "./CobrancaListFilters.vue?vue&type=script&lang=js&"
import style0 from "./CobrancaListFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports